
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Retencion</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitBenefir(withholdingGroupForm)" #withholdingGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<!--mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header-->
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="withholding.description" [(ngModel)]="withholding.description">
								<mat-error>{{ violations['withholding.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="withholding.attribute" [(ngModel)]="withholding.attribute" (keydown.space)="$event.preventDefault()">
								<mat-error>{{ violations['withholding.attribute'] }}</mat-error>
							</mat-form-field>
						</div>
                        <div class="control">
                            <mat-form-field class="controlWidth">
                              <mat-label>Tipo Retencion</mat-label>
                              <mat-select [(ngModel)]="withholding.withholdingType"  [compareWith]="compareWithholdingTypes" name="withholding.withholdingType" >
                              @for (withholdingType of withholdingTypes ; track withholdingType.id) {
                                <mat-option [value]="withholdingType">{{ withholdingType.description }}</mat-option>
                              }
                            </mat-select>
							<mat-error>{{ violations['withholding.withholdingType'] }}</mat-error>
							<mat-error *ngIf="violations['withholding.withholdingType']">
								{{ violations['withholding.withholdingType'] }}
							  </mat-error>
                            </mat-form-field>
                        </div>
						<div class="control">
							<mat-slide-toggle [(ngModel)]="withholding.active"  name="withholdingActive" > 
							  {{ withholding.active? 'Retencion Activo':'Retencion Inactivo'}} 
							</mat-slide-toggle>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(withholding.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>